module.exports = __webpack_public_path__ + "static/img/sustainable-solutions-rnd-accenture.80f5504.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/sustainable/sustainable-solutions-rnd-accenture.png
// module id = Qsoa
// module chunks = 0